import type { Item } from '@mn/shared';

// ── Item catalog: ~20 items across all ItemKind values. ──
// capture tools (tiers) | heals | tools (utility) | materials | key items.

export const ITEMS: Item[] = [
  // ── Capture tools (tiered; higher tier = better catch multiplier, set in battle logic) ──
  { id: 'it_snare', name: 'Snare Trap', kind: 'capture', stackable: true,
    description: 'Basic capture tool. Cheap and plentiful; weak hold on tough beasts.' },
  { id: 'it_net', name: 'Hunter Net', kind: 'capture', stackable: true,
    description: 'Standard capture net. Reliable on early- and mid-game beasts.' },
  { id: 'it_rune_trap', name: 'Rune Trap', kind: 'capture', stackable: true,
    description: 'Etched capture trap. Markedly higher hold rate on stubborn quarry.' },
  { id: 'it_apex_binding', name: 'Apex Binding', kind: 'capture', stackable: true,
    description: 'Master-tier capture tool. Best odds against rare and apex beasts.' },

  // ── Heals ──
  { id: 'it_salve', name: 'Field Salve', kind: 'heal', stackable: true,
    description: 'Restores a small amount of HP to one beast.' },
  { id: 'it_poultice', name: 'Herb Poultice', kind: 'heal', stackable: true,
    description: 'Restores a moderate amount of HP to one beast.' },
  { id: 'it_elixir', name: 'Vital Elixir', kind: 'heal', stackable: true,
    description: 'Fully restores HP to one beast.' },
  { id: 'it_revive_charm', name: 'Revive Charm', kind: 'heal', stackable: true,
    description: 'Revives a fainted beast to half HP.' },
  { id: 'it_antidote', name: 'Antidote', kind: 'heal', stackable: true,
    description: 'Cures venom and other status afflictions on one beast.' },

  // ── Tools (utility, non-capture) ──
  { id: 'it_bait', name: 'Beast Bait', kind: 'tool', stackable: true,
    description: 'Increases the wild encounter rate in the current realm for a short time.' },
  { id: 'it_repellent', name: 'Wild Repellent', kind: 'tool', stackable: true,
    description: 'Suppresses low-level wild encounters while exploring.' },
  { id: 'it_xp_charm', name: 'Training Charm', kind: 'tool', stackable: true,
    description: 'Held tool: the bearer gains bonus XP from battles.' },
  { id: 'it_recall_flare', name: 'Recall Flare', kind: 'tool', stackable: true,
    description: 'Instantly returns you to Town. Useless inside the Badlands.' },

  // ── Materials (sellable / used for evolution & crafting later) ──
  { id: 'mat_emberstone', name: 'Emberstone', kind: 'material', stackable: true,
    description: 'A warm shard harvested from Flame beasts. Tradeable on the market.' },
  { id: 'mat_tidepearl', name: 'Tidepearl', kind: 'material', stackable: true,
    description: 'A luminous pearl from Tide beasts. Tradeable on the market.' },
  { id: 'mat_heartwood', name: 'Heartwood', kind: 'material', stackable: true,
    description: 'Dense core-wood shed by Verdant beasts. Tradeable on the market.' },
  { id: 'mat_apex_fang', name: 'Apex Fang', kind: 'material', stackable: true,
    description: 'A trophy fang from a defeated apex beast. Rare and highly valued.' },

  // ── Key items (non-stackable, account/progress gated) ──
  { id: 'key_portal_charm', name: 'Portal Charm', kind: 'key', stackable: false,
    description: 'Attunes you to the realm portals. Required to leave Town.' },
  { id: 'key_badlands_pass', name: 'Badlands Pass', kind: 'key', stackable: false,
    description: 'Grants entry to the open-PvP Badlands. Carry it at your own risk.' },
  { id: 'key_arena_token', name: 'Arena Sigil', kind: 'key', stackable: false,
    description: 'Registers you for ranked Arena matchmaking in Town.' },
  { id: 'key_spinner_ticket', name: 'Spinner Ticket', kind: 'key', stackable: false,
    description: 'Proof of a paid spin. Consumed when the daily spinner resolves.' },
];

export const ITEMS_BY_ID: Record<string, Item> = Object.fromEntries(
  ITEMS.map((i) => [i.id, i]),
);
